<section id="profile-info">
                <div class="row">
                    <div class="col-lg-12 col-12 order-1 order-lg-2">
                        <div class="form-group mb-2">
                            <div class="card">
                                <div class="card-header">
                                    <h2>Contact</h2>
                                </div>
                                <div class="card-body">
                                    <small>Contact Info</small>
                                    <quill-editor class="university-info" [(ngModel)]="data"
                                                  name="quill-content"></quill-editor>
                                </div>
                                <div class="card-body">
                                    <small>Map</small>
                                    <textarea class="form-control resize-none" id="map" type="text" rows="3"
                                              [(ngModel)]="map"></textarea>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-primary pull-right" rippleEffect (click)="submit()">
                                        <i data-feather="submit" class="d-block d-md-none"></i>
                                        <span class="font-weight-bold d-none d-md-block">Submit</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
